import axios from 'axios';
import {
  ADD_INSTRUCTION,
  EDIT_INSTRUCTION,
  FETCH_TRAINER_INSTRUCTIONS,
  FETCH_INSTRUCTION_CATS
} from '../actionTypes';
import { showAlert } from './alert';
import { hideLoader, showLoader } from './loader';

const SERVICE = `instructions`;

export const fetchMyInstructions = query => dispatch => {
	console.log(query)
	dispatch(showLoader());
	return new Promise(function (resolve, reject) {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.get(SERVICE, {
				params: query
			})
			.then(res => {
				dispatch(hideLoader());
				dispatch({
					type: FETCH_TRAINER_INSTRUCTIONS,
					payload: res.data,
				});
				return resolve(res['data']);
			});
	});
};


export const editInstruction = (editId, instruction, user) => dispatch => {
	if (!editId) {
		console.error('instruction does not have id');
		return false;
	}
	dispatch(showLoader());
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	return axios
		.patch(`${SERVICE}/${editId}`, instruction)
		.then(res => {
			dispatch(hideLoader());
			dispatch(showAlert('YouTube updated successfully.'));
			return dispatch({
				type: EDIT_INSTRUCTION,
				payload: {
					[res.data._id]: res.data,
				},
				user: user,
			});
		})
		.catch(function (error) {
			dispatch(hideLoader());
			dispatch(showAlert(error.toString(), true));
			console.warn(error);
		});
};

export const updateOrder = (instruction) => dispatch => {
	dispatch(showLoader());
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	return axios
		.patch(`${SERVICE}/orders/update`, instruction)
		.then(res => {
			dispatch(hideLoader());
			return res;
		})
		.catch(function (error) {
			dispatch(hideLoader());
			dispatch(showAlert(error.toString(), true));
			console.warn(error);
		});
};

export const deleteInstruction = (id) => dispatch => {
	if (!id) {
		console.error('instruction does not have id');
		return false;
	}
	dispatch(showLoader());
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	return axios
		.delete(`${SERVICE}/${id}`)
		.then(res => {
			dispatch(hideLoader());
			dispatch(showAlert('Instruction deleted successfully.'));
			return res;
		})
		.catch(function (error) {
			dispatch(hideLoader());
			dispatch(showAlert(error.toString(), true));
		});
};



export const addInstruction = (instructionData, user) => (dispatch, getState) => {
	dispatch(showLoader());
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	// instructionData.name = instructionData.name
	// 	.toLowerCase()
	// 	.split(' ')
	// 	.map(s => s.charAt(0).toUpperCase() + s.substring(1))
	// 	.join(' ');
	return axios
		.post(SERVICE, instructionData)
		.then(res => {
			dispatch(hideLoader());
			if (res.data._id) {
				dispatch(showAlert('YouTube has been saved successfully. Please go to library section for edit it.'));
				dispatch({
					type: ADD_INSTRUCTION,
					payload: {
						[res.data._id]: res.data,
					},
					user: user,
				});
			} else {
				console.error('Failed to add instruction.', instructionData);
			}
		})
		.catch(function (error) {
			dispatch(hideLoader());
			console.warn(error);
			dispatch(showAlert('Failed to add instruction.', true));
		});
};


export const fetchFormValues = (userId) => (dispatch) => {
	const promises = [];
	dispatch(showLoader());
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	promises.push(axios.get('categories',{params:{type:'instructions'}}));
	return new Promise((respond,rej) => {
	  Promise.all(promises).then((values) => {
		const instructionCats = values[0].data;
		dispatch({
		  type: FETCH_INSTRUCTION_CATS,
		  payload: instructionCats
		});
		dispatch(hideLoader());
		respond();
	  });
	});
}




// WEBPACK FOOTER //
// ./src/store/actions/instructions.js